import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { TwitterService } from '../../_services/twitter.service';
import { Subject } from 'rxjs/Subject';
import { DialogService } from 'ng2-bootstrap-modal';
import { ConfirmComponent } from '../../_common/confirm/confirm.component';
import { AddTwitterComponent } from './add-twitter/add-twitter.component';

@Component({
    selector: 'app-twitter',
    templateUrl: './twitter.component.html'
})
export class TwitterComponent implements OnInit {
    users: any;
    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    dtTrigger: Subject<any> = new Subject();

    //declare parameters object
    parameters: any = {};

    //declare callback object
    callback: any = {};

    constructor(private twitterService: TwitterService,
        private dialogService: DialogService) { }

    ngOnInit() {
        this.initDataTables();
    }

    initDataTables() {

        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.searchWord || '';

                //assign parameters object
                self.parameters = parameters;

                //assign callback object
                self.callback = callback;

                self.twitterService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: "URL",
                    data: "url",
                    name: "url",
                    className: "all text-justify"
                },
                {
                    title: "",
                    data: "btn_is_stopped",
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function () {
                        return `<button class="btn btn-sm btn-danger btn-delete">削除</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;
                $('.btn_is_stopped', row).bind('click', () => {
                    self.stop(data);
                });
                $('.btn-delete', row).bind('click', () => {
                    self.confirmDelete(data);
                });
                return row;
            }
        };
    }

    valuechange(newValue) {
        this.searchWord = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600);
    };

    stop(data) {
        this.twitterService.stop(data).subscribe(data => {
            this.loadCurrentPage();
        }, error => {

        });
    }

    confirmDelete(data) {
        this.dialogService.addDialog(ConfirmComponent, {
            title: '確認',
            message: '削除しますが、よろしいでしょうか？'
        }).subscribe((isConfirmed) => {
            if (isConfirmed) {
                this.twitterService.delete(data.id).subscribe(data => {
                    this.loadCurrentPage();
                }, error => {

                });
            }
        });
    }

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    openModalAddLineUser() {
        let self = this;
        this.dialogService.addDialog(AddTwitterComponent).subscribe((isAccess) => {
            this.loadCurrentPage();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.twitterService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/twitter/twitter.component.ts